import api from '@/api'

let Q = require('q')

const state = {
  demarcaciones: []
}

const getters = {
  demarcaciones: (state) => {
    return state.demarcaciones
  }
}

const mutations = {
  SET_DEMARCACIONES (state, demarcaciones) {
    state.demarcaciones = demarcaciones
  }
}

const actions = {
  async fetchDemarcaciones ({ commit }) {
    let deferred = Q.defer()
    try {
      const response = await api.demarcacion.getDemarcaciones()
      commit('SET_DEMARCACIONES', response.data)
      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }
    return deferred.promise
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
